<template>
    <record-dialog
        :title="title"
        :preTitle="!clone"
        :width="clone === 'cloud' ? '550px' : '460px'"
        :verifyDirty="!(clone && clone.match(/cloud/))"
        v-bind="$attrs"
        :defaultRec="{
            name: null,
            description: null,
            intervention_form: false,
            live: 1,
        }"
        @create="createRec"
        @update="$emit('update',$event)"
        @close="$emit('close')"
        :acceptBtnText="clone === 'cloud' ? 'Download Template' : null"
    >
        <template #form="{rec}">
            <div v-if="clone === 'cloud'" class="mb-5">
                Download a pre-made template from the climberCLOUD. Once downloaded, you can find the template under District Templates where you can customize the form to meet your district's needs.
            </div>
            <fe-label style="font-size: 14px" class="mb-2">Template Name</fe-label>
            <v-text-field flat solo dense autofocus
                v-model="rec.name"
                :rules="$fieldValidators('text', null, {required:true, limit:50}).concat(
                    v => v && !templates.some(x => x.name==v ) || 'Name already used'
                )"
            />
            <fe-label style="font-size: 14px" class="mb-2">Template Description</fe-label>
            <v-textarea flat solo dense
                v-model="rec.description"
                :height="clone === 'cloud' ? 150 : 64"
                :counter="255"
                :rules="$fieldValidators('text', null, {required:true, limit:255})"
            />
            <div v-if="canCreateLiveTemplate && (!updating || duplicating || clone === 'cloud')">
                <fe-label style="font-size: 14px" class="mb-4">Template Type</fe-label>
                <v-radio-group v-model="rec.live" class="add-template-radio-group">
                    <v-radio :value="1" data-test="add-template-radio-true">
                        <template v-slot:label>
                        <div>
                            <div style="font-size: 14px">Live Template</div>
                            <div style="color:#495B8F">Any changes made to the template automatically update existing forms using it.</div>
                        </div>
                        </template>
                    </v-radio>
                    <v-radio :value="0" data-test="add-template-radio-false">
                        <template v-slot:label>
                        <div>
                            <div style="font-size: 14px">Versioned Template</div>
                            <div style="color:#495B8F">Any changes made to the template will NOT update existing forms using it.</div>
                        </div>
                        </template>
                    </v-radio>
                </v-radio-group>
            </div>
            <div v-if="!clone">
                <fe-label style="font-size: 14px" class="mb-4">Intervention Referral Form</fe-label>
                <div class="d-flex">
                    <v-checkbox v-model="rec.intervention_form" aria-label="Intervention Referral Form" data-test="add-template-intervention-checkbox" />
                    <span>Automatically display form in an attached student's intervention</span>
                </div>
            </div>
            <fe-crud ref="crud" :config="$models.form" @read="templates=$event" :readParams="{ignore_permissions:1}" :autoload="true" />
        </template>

    </record-dialog>
</template>

<script>
import { mapState } from 'vuex'
import RecordDialog from '@/components/common/form/RecordDialog'

export default {
    name: 'AddTemplate',
    
    components: {
        RecordDialog
    },
    
    props: {
        create: {type:Boolean, default:false},
        clone: {type:String, default:null},
    },
    
    computed: {
        ...mapState('global',['sessionUser']),
        liveTemplatesEnabled: me => me.$store.getters['flags/flags']['ec-live-template'] === true,
        canCreateLiveTemplate() {
            return this.liveTemplatesEnabled && this.clone !== 'to_the_cloud'
        },
        title() {
            if(this.clone === 'local') return 'Copy Template'
            if(this.clone === 'cloud') return 'Download Template from climberCLOUD'
            if(this.clone === 'to_the_cloud') return 'Copy Template to climberCLOUD'
            return 'Template'
        },
        updating() {
            return this.$children[0].updating
        },
        duplicating() {
            return this.clone === 'local'
        },
    },

    mounted() {
        // rec.live can arrive from the API as a boolean; the radio group below expects 1/0
        this.$children[0].rec.live = this.$children[0].rec.live ? 1 : 0
    },

    methods: {
        createRec(rec) {
            if(this.create) {
                this.$refs.crud.create(rec).then( r => {
                    this.$emit('created',rec)
                    this.$emit('close')
                })
            } else {
                this.$emit('create',rec)
            }
        }
    },

    data() {
        return {
            templates: [],
        }
    },
}
</script>

<style lang="scss" scoped>
.add-template-radio-group {
    ::v-deep .v-radio {
         display:flex;
         align-items:flex-start;
    }
}
</style>
